import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "@/core/utils/date";
import { IInternalTransaction } from "@/internal-transactions/InternalTransactions";

export const DateInitiatedCol = (): ColumnDef<IInternalTransaction> => ({
  header: "Date initiated",
  accessorKey: "created_at",
  cell: ({ row }) => formatDate(row.original.created_at),
});
